import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/verification";

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
};

/** The proof file as a Blob (it sits behind the admin login, so no plain link). */
export const Proof = async (params) => {
    return await axiosInstance(options).get(`${path}/proof`, { params, responseType: "blob" });
};

export const ApproveConsultations = async (values) => {
    return await axiosInstance(options).post(`${path}/approve-consultations`, values);
};

export const RejectConsultations = async (values) => {
    return await axiosInstance(options).post(`${path}/reject-consultations`, values);
};

export const ApproveReview = async (values) => {
    return await axiosInstance(options).post(`${path}/approve-review`, values);
};

export const RejectReview = async (values) => {
    return await axiosInstance(options).post(`${path}/reject-review`, values);
};
